const header = document.querySelector("[data-header]");
const menuToggle = document.querySelector(".menu-toggle");

menuToggle?.addEventListener("click", () => {
  const isOpen = header.classList.toggle("nav-open");
  menuToggle.setAttribute("aria-expanded", String(isOpen));
});

document.querySelectorAll("[data-nav-category] > a").forEach((link) => {
  const category = link.closest("[data-nav-category]");

  category?.addEventListener("mouseenter", () => {
    if (!window.matchMedia("(max-width: 860px)").matches) {
      document.querySelectorAll("[data-nav-category].is-open").forEach((item) => {
        if (item !== category) item.classList.remove("is-open");
      });
      category.classList.add("is-open");
    }
  });

  category?.addEventListener("mouseleave", () => {
    if (!window.matchMedia("(max-width: 860px)").matches) {
      category.classList.remove("is-open");
    }
  });

  category?.addEventListener("pointerenter", () => {
    if (!window.matchMedia("(max-width: 860px)").matches) {
      document.querySelectorAll("[data-nav-category].is-open").forEach((item) => {
        if (item !== category) item.classList.remove("is-open");
      });
      category.classList.add("is-open");
    }
  });

  category?.addEventListener("pointerleave", () => {
    if (!window.matchMedia("(max-width: 860px)").matches) {
      category.classList.remove("is-open");
    }
  });

  link.addEventListener("click", (event) => {
    const isMobileNav = window.matchMedia("(max-width: 860px)").matches && header?.classList.contains("nav-open");
    const isOpen = category?.classList.contains("is-open");

    if (isMobileNav) {
      event.preventDefault();
      document.querySelectorAll("[data-nav-category].is-open").forEach((item) => {
        if (item !== category) item.classList.remove("is-open");
      });
      category?.classList.toggle("is-open", !isOpen);
      return;
    }

    if (!window.matchMedia("(max-width: 860px)").matches && category?.querySelector(".mega-menu")) {
      if (!isOpen) {
        event.preventDefault();
        document.querySelectorAll("[data-nav-category].is-open").forEach((item) => {
          if (item !== category) item.classList.remove("is-open");
        });
        category.classList.add("is-open");
      }
    }
  });
});

document.addEventListener("click", (event) => {
  if (!event.target.closest("[data-nav-category]")) {
    document.querySelectorAll("[data-nav-category].is-open").forEach((item) => item.classList.remove("is-open"));
  }
});

document.querySelectorAll("[data-hero-slider]").forEach((slider) => {
  const slides = [...slider.querySelectorAll("[data-hero-slide]")];
  const dots = [...slider.querySelectorAll("[data-hero-dot]")];
  if (slides.length <= 1) return;

  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
  let timer;

  const showSlide = (index) => {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle("is-active", slideIndex === activeIndex);
    });
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === activeIndex;
      dot.classList.toggle("is-active", isActive);
      dot.setAttribute("aria-current", String(isActive));
    });
  };

  const start = () => {
    timer = window.setInterval(() => showSlide(activeIndex + 1), 6000);
  };

  const stop = () => {
    if (timer) window.clearInterval(timer);
  };

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      stop();
      showSlide(Number(dot.dataset.heroDot || 0));
      start();
    });
  });

  slider.addEventListener("mouseenter", stop);
  slider.addEventListener("mouseleave", start);
  slider.addEventListener("focusin", stop);
  slider.addEventListener("focusout", start);

  showSlide(activeIndex);
  start();
});

document.querySelectorAll(".accordion-item").forEach((button) => {
  button.addEventListener("click", () => {
    const panel = button.nextElementSibling;
    const mark = button.querySelector("strong");
    const isOpen = panel.classList.toggle("is-open");
    mark.textContent = isOpen ? "-" : "+";
  });
});

document.querySelectorAll("[data-brand-scroll]").forEach((button) => {
  button.addEventListener("click", () => {
    const carousel = button.closest(".brand-carousel");
    const strip = carousel?.querySelector("[data-brand-strip]");
    if (!strip) return;

    const direction = button.dataset.brandScroll === "prev" ? -1 : 1;
    strip.scrollBy({
      left: direction * Math.max(strip.clientWidth * 0.72, 180),
      behavior: "smooth",
    });
  });
});

document.querySelectorAll(".shopify-policy__body .rte").forEach((policyBody) => {
    policyBody.classList.add("policy-rte");
});

const bindProductThumbs = (scope = document) => {
  scope.querySelectorAll("[data-product-thumb]").forEach((thumb) => {
    if (thumb.dataset.thumbReady === "true") return;
    thumb.dataset.thumbReady = "true";

    thumb.addEventListener("click", (event) => {
      const productTemplate = thumb.closest(".product-template");
      const mainImage = productTemplate?.querySelector("[data-product-main-image]");
      if (!mainImage || !thumb.dataset.productThumbImage) return;

      event.preventDefault();
      mainImage.src = thumb.dataset.productThumbImage;
      mainImage.removeAttribute("srcset");
      mainImage.alt = thumb.dataset.productThumbAlt || mainImage.alt;

      productTemplate.querySelectorAll("[data-product-thumb]").forEach((item) => {
        const isSelectedThumb = item === thumb;
        item.classList.toggle("is-selected", isSelectedThumb);
        item.setAttribute("aria-current", String(isSelectedThumb));
      });
    });
  });
};

const linkedProductTemplateCache = new Map();

const getLinkedProductSectionUrl = (url, sectionId) => {
  const sectionUrl = new URL(url, window.location.origin);
  if (sectionId) sectionUrl.searchParams.set("section_id", sectionId);
  return sectionUrl.toString();
};

const getLinkedProductTemplate = async (url, sectionId) => {
  const sectionUrl = getLinkedProductSectionUrl(url, sectionId);
  const cachedTemplate = linkedProductTemplateCache.get(sectionUrl);
  if (cachedTemplate) return cachedTemplate.cloneNode(true);

  const response = await fetch(sectionUrl, {
    credentials: "same-origin",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  });
  if (!response.ok) throw new Error("Variant request failed");

  const html = await response.text();
  const nextDocument = new DOMParser().parseFromString(html, "text/html");
  const nextTemplate = nextDocument.querySelector(".product-template");
  if (!nextTemplate) throw new Error("Variant template missing");

  linkedProductTemplateCache.set(sectionUrl, nextTemplate);
  return nextTemplate.cloneNode(true);
};

const bindLinkedProductOptions = (scope = document) => {
  scope.querySelectorAll("[data-product-form]").forEach((form) => {
    if (form.dataset.linkedOptionsReady === "true") return;
    if (form.querySelector("[data-variant-select]")) return;
    const linkedOptions = [...form.querySelectorAll('a.option-button[href*="variant="]')];
    if (!linkedOptions.length) return;

    form.dataset.linkedOptionsReady = "true";

    linkedOptions.forEach((button) => {
      const prefetchLinkedOption = () => {
        if (button.dataset.variantPrefetchReady === "true") return;
        if (button.getAttribute("aria-disabled") === "true" || button.classList.contains("is-disabled")) return;

        const url = button.href;
        if (!url) return;

        const productTemplate = form.closest(".product-template");
        const sectionId = productTemplate?.dataset.productSectionId || "";
        button.dataset.variantPrefetchReady = "true";
        getLinkedProductTemplate(url, sectionId).catch(() => {});
      };

      button.addEventListener("pointerenter", prefetchLinkedOption, { once: true });
      button.addEventListener("focus", prefetchLinkedOption, { once: true });

      button.addEventListener("click", async (event) => {
        if (button.getAttribute("aria-disabled") === "true" || button.classList.contains("is-disabled")) {
          event.preventDefault();
          return;
        }

        const url = button.href;
        if (!url) return;

        event.preventDefault();
        const productTemplate = form.closest(".product-template");
        const sectionId = productTemplate?.dataset.productSectionId || "";
        productTemplate?.classList.add("is-loading-variant");

        try {
          const nextTemplate = await getLinkedProductTemplate(url, sectionId);
          if (!productTemplate || !nextTemplate) throw new Error("Variant template missing");

          productTemplate.replaceWith(nextTemplate);
          window.history.replaceState({}, "", url);
          bindLinkedProductOptions(nextTemplate);
          bindProductThumbs(nextTemplate);
        } catch (error) {
          window.location.href = url;
        }
      });
    });
  });
};

document.addEventListener("click", (event) => {
  const stepButton = event.target.closest("[data-quantity-step]");
  if (!stepButton) return;

  const control = stepButton.closest(".quantity-control");
  const input = control?.querySelector('input[name="quantity"]');
  if (!input) return;

  const step = Number(stepButton.dataset.quantityStep || 0);
  const minimum = Number(input.min || 1);
  const current = Number(input.value || minimum);
  input.value = String(Math.max(minimum, current + step));
  input.dispatchEvent(new Event("change", { bubbles: true }));
});

document.querySelectorAll("[data-product-form]").forEach((form) => {
  const select = form.querySelector("[data-variant-select]");
  const status = form.querySelector("[data-variant-status]");
  const groups = [...form.querySelectorAll("[data-option-index]")];
  const productTemplate = form.closest(".product-template");
  const mainImage = productTemplate?.querySelector("[data-product-main-image]");
  const productPrice = productTemplate?.querySelector("[data-product-price]");
  const productAvailability = productTemplate?.querySelector("[data-product-availability]");
  if (!select || !groups.length) return;

  let selected = groups.map((group) => {
    return group.querySelector(".option-button.is-selected")?.dataset.optionValue || "";
  });

  const variantOptions = [...select.options].map((option) => {
    return {
      option,
      values: option.dataset.options?.split("||").map((value) => value.trim()) || [],
      disabled: option.disabled,
      price: Number(option.dataset.price || 0),
      image: option.dataset.variantImage || "",
      imageAlt: option.dataset.variantImageAlt || "",
    };
  });

  const formatMoney = (cents) => {
    return `$${(Math.round(cents) / 100).toFixed(2)}`;
  };

  const updateBulkPrices = (price) => {
    form.querySelectorAll("[data-bulk-price]").forEach((priceNode) => {
      const discount = Number(priceNode.dataset.discount || 100);
      priceNode.textContent = formatMoney((price * discount) / 100);
    });
  };

  const updateProductPrice = (price) => {
    if (!productPrice) return;
    const label = productPrice.querySelector("span")?.outerHTML || "<span>Price</span>";
    productPrice.innerHTML = `${label} ${formatMoney(price)}`;
  };

  const updateProductAvailability = (available) => {
    if (!productAvailability) return;
    productAvailability.textContent = available ? "In stock" : "Unavailable";
    productAvailability.classList.toggle("is-unavailable", !available);
  };

  const updateProductImage = (item) => {
    if (!mainImage || !item?.image) return;
    mainImage.src = item.image;
    mainImage.removeAttribute("srcset");
    mainImage.alt = item.imageAlt || mainImage.alt;

    productTemplate?.querySelectorAll("[data-product-thumb]").forEach((thumb) => {
      const isSelectedThumb = thumb.dataset.productThumbImage === item.image;
      thumb.classList.toggle("is-selected", isSelectedThumb);
      thumb.setAttribute("aria-current", String(isSelectedThumb));
    });
  };

  const applySelectedState = () => {
    groups.forEach((group, index) => {
      group.querySelectorAll(".option-button").forEach((button) => {
        const isSelected = button.dataset.optionValue === selected[index];
        button.classList.toggle("is-selected", isSelected);
        button.setAttribute("aria-pressed", String(isSelected));
      });
    });
  };

  const hasMatch = (values) => {
    return variantOptions.some((item) => {
      return !item.disabled && item.values.every((value, index) => !values[index] || value === values[index]);
    });
  };

  const refreshAvailability = () => {
    groups.forEach((group) => {
      const index = Number(group.dataset.optionIndex);
      group.querySelectorAll(".option-button").forEach((button) => {
        const trial = [...selected];
        trial[index] = button.dataset.optionValue;
        const available = hasMatch(trial);
        button.disabled = !available;
        button.classList.toggle("is-disabled", !available);
        button.setAttribute("aria-disabled", String(!available));
      });
    });
  };

  const updateVariant = () => {
    const match = variantOptions.find((item) => {
      return item.values.every((value, index) => value === selected[index]);
    });

    if (match) {
      select.value = match.option.value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
      updateProductPrice(match.price);
      updateBulkPrices(match.price);
      updateProductImage(match);
      updateProductAvailability(!match.disabled);
      if (status) status.textContent = match.disabled ? "This option is currently unavailable." : "";
      form.querySelector('[type="submit"]').disabled = match.disabled;
    } else {
      updateProductAvailability(false);
      if (status) status.textContent = "This combination is not available.";
      form.querySelector('[type="submit"]').disabled = true;
    }
    refreshAvailability();
  };

  if (!variantOptions.some((item) => item.values.every((value, index) => value === selected[index]))) {
    const firstAvailable = variantOptions.find((item) => !item.disabled) || variantOptions[0];
    if (firstAvailable) {
      selected = [...firstAvailable.values];
      applySelectedState();
    }
  }

  groups.forEach((group) => {
    const index = Number(group.dataset.optionIndex);
    group.querySelectorAll(".option-button").forEach((button) => {
      button.addEventListener("click", () => {
        if (button.disabled) return;
        group.querySelectorAll(".option-button").forEach((item) => {
          item.classList.remove("is-selected");
          item.setAttribute("aria-pressed", "false");
        });
        button.classList.add("is-selected");
        button.setAttribute("aria-pressed", "true");
        selected[index] = button.dataset.optionValue;
        updateVariant();
      });
    });
  });

  updateVariant();
});

bindLinkedProductOptions();
bindProductThumbs();
